module.exports = __webpack_public_path__ + "img/panchito.png.bbe6c50b.webp";